(function ($) {
  ("use strict");

  $(document).ready(function () {
    // Comments
    $(".commentlist li").addClass("card mb-3");
    $(".comment-reply-link").addClass("btn btn-secondary");

    // Forms
    $("select, input[type=text], input[type=email], input[type=password], textarea").addClass("form-control");
    $("input[type=submit]").addClass("btn btn-primary");
    $("select").addClass("form-select");

    // Pagination fix for ellipsis
    $(".pagination .dots").addClass("page-link").parent().addClass("disabled");

    //Play cta: hide poster display video onclick
    $(".play").click(function () {
      $(this).parent().siblings(".video").removeClass("hide");
      $(this).closest(".poster").addClass("hide");
    });

    //Readmore cta
    $("#readmore").click(function () {
      if ($(this).html() === "Read more") {
        $(this).html("Read less");
        $("#showmore").removeClass("hide");
      } else {
        $(this).html("Read more");
        $("#showmore").addClass("hide");
      }
    });

    // copy to clipboard
    $(".to-clipboard").click(function () {
      var $temp = $("<input>");
      var $url = $(location).attr("href");
      $("body").append($temp);
      $temp.val($url).select();
      document.execCommand("copy");
      $temp.remove();
      $("#copied_url").removeClass("vis-hidden");
    });

    //Sliders
    if ($("#slider_dsiltr_items_upper").length > 0) {
      $("#slider_dsiltr_items_upper").slick({
        asNavFor: "#slider_dsiltr_items_lower",
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              arrows: false,
            },
          },
        ],
      });
    }
    if ($("#slider_dsiltr_items_lower").length > 0) {
      $("#slider_dsiltr_items_lower").slick({
        asNavFor: "#slider_dsiltr_items_upper",
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              dots: true,
            },
          },
        ],
      });
    }
    //double slider icons bottom
    if ($("#double-slider-icons-bottom-upper").length > 0) {
      $("#double-slider-icons-bottom-upper").slick({
        asNavFor: "#double-slider-icons-bottom-lower",
        fade: true,
        cssEase: 'linear',
        arrows: true,
        prevArrow:"<button type='button' class='prev in_caption'></button>",
        nextArrow:"<button type='button' class='next in_caption'></button>"
      });
    }
    if ($("#double-slider-icons-bottom-lower").length > 0) {
      $("#double-slider-icons-bottom-lower").slick({
        asNavFor: "#double-slider-icons-bottom-upper",
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    //footer mobile sliders
    if ($("#footer-image-slider").length > 0) {
      $("#footer-image-slider").slick({
        asNavFor: "#footer-location-slider,#footer-contactdetails-slider",
        arrows: false,
      });
    }
    if ($("#footer-location-slider").length > 0) {
      $("#footer-location-slider").slick({
        asNavFor: "#footer-image-slider, #footer-contactdetails-slider",
        arrows: false,
        centerMode: true,
        centerPadding: "60px",
      });
    }
    if ($("#footer-contactdetails-slider").length > 0) {
      $("#footer-contactdetails-slider").slick({
        asNavFor: "#footer-location-slider, #footer-image-slider",
        arrows: false,
      });
    }

    //stop event propagation for menu items with children
    let dropDownButton = document.querySelectorAll(".dropdown-item");
    dropDownButton.forEach((e) => {
      if (e.dataset.bsToggle === "dropdown") {
        e.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      }
    });

    //autopause modal box videos
    stopVideos = () => {
      var videos = document.querySelectorAll("iframe, video");
      Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          var src = video.src;
          video.src = src;
        }
      });
    };

    // Use Bootstrap 5's event for modals
    const modals = document.querySelectorAll('.modal');
    modals.forEach(modal => {
      modal.addEventListener('hidden.bs.modal', function () {
        stopVideos();
      });
    });
  });

  //update mobile select for sibling pages side menu
  if (document.getElementById("sidebarMobileSelect")) {
    let url = window.location.href;
    let categorySelect = document.getElementById("sidebarMobileSelect");
    categorySelect.value = url;
  }
  
  $(window).on('resize', function() {
      $('.form-group').each(function() {
          var formGroup = $(this),
              formgroupWidth = formGroup.outerWidth();
          
          formGroup.find('.select2-container').css('width', formgroupWidth);
      });
  });
})(jQuery);

function copyUrl() {
  if (!window.getSelection) {
    alert("Please copy the URL from the location bar.");
    return;
  }
  const dummy = document.createElement("p");
  dummy.textContent = window.location.href;
  document.body.appendChild(dummy);

  const range = document.createRange();
  range.setStartBefore(dummy);
  range.setEndAfter(dummy);

  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand("copy");
  document.body.removeChild(dummy);
}
